import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexCandidateSessions(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get("v1/candidates/sessions/", { params });
}

export function showCandidateSession(
  sessionId: number | string
): Promise<ApiResponse> {
  return Axios.get(`v1/candidates/sessions/${sessionId}`);
}

export function RequestQualifiedCandidateSchedules(
  scheduleSlotData: object
): Promise<ApiResponse> {
  return Axios.post("v1/candidates/proposed_schedules", scheduleSlotData);
}
